module.exports = __webpack_public_path__ + "img/Me-02.2924cbd5.jpg";